document.addEventListener('DOMContentLoaded', function () {
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const drawer = document.getElementById('mobile-drawer');
  const body = document.body;

  // iOS Detection
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isIOS) {
    document.documentElement.classList.add('is-ios-device');
  }

  if (!menuToggle || !drawer) return;

  // Store scroll position for iOS lock
  let savedScrollY = 0;

  // Toggle Drawer
  menuToggle.addEventListener('click', function () {
    const isActive = drawer.classList.contains('is-active');

    if (isActive) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  function openDrawer() {
    drawer.classList.add('is-active');
    menuToggle.classList.add('is-active');
    body.classList.add('drawer-open');
    drawer.setAttribute('aria-hidden', 'false');

    // iOS Specific Scroll Lock
    if (isIOS) {
      savedScrollY = window.scrollY;
      body.style.position = 'fixed';
      body.style.top = `-${savedScrollY}px`;
      body.style.width = '100%';
      // Prevent bounces and unwanted scrolls
      body.style.overscrollBehavior = 'none';
      document.documentElement.style.scrollBehavior = 'auto'; // Prevent smooth scroll fight
    }

    // Reset to main panel when opening
    showPanel('panel-main');
  }

  function closeDrawer() {
    drawer.classList.remove('is-active');
    menuToggle.classList.remove('is-active');
    body.classList.remove('drawer-open');
    drawer.setAttribute('aria-hidden', 'true');

    // iOS Specific Scroll Unlock
    if (isIOS) {
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      body.style.overscrollBehavior = '';
      document.documentElement.style.scrollBehavior = '';

      // Restore scroll position
      window.scrollTo(0, savedScrollY);
    }
  }

  // Panel Management
  const categoryCards = document.querySelectorAll('.category-card');
  const backButtons = document.querySelectorAll('.mobile-drawer__back');

  categoryCards.forEach(card => {
    card.addEventListener('click', function () {
      const targetPanelId = this.getAttribute('data-target');
      showPanel(targetPanelId);
    });
  });

  backButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      const targetPanelId = this.getAttribute('data-target');
      showPanel(targetPanelId);
    });
  });

  function showPanel(panelId) {
    const panels = document.querySelectorAll('.mobile-drawer__panel');
    panels.forEach(panel => {
      if (panel.id === panelId) {
        panel.classList.add('is-active');
      } else {
        panel.classList.remove('is-active');
      }
    });

    // Track current panel for UI visibility logic
    drawer.setAttribute('data-current-panel', panelId);

    // Animate transition (simple CSS handle usually enough, but we can ensure layout)
    const activePanel = document.getElementById(panelId);
    if (activePanel) {
      activePanel.scrollTop = 0;
    }
  }

  // Close drawer on background click if we had an overlay (currently drawer fills screen)
  // If we want clicking the logo or other icons to close drawer
  const headerLinks = document.querySelectorAll('.mobile-header__logo-link, .mobile-header__icon');
  headerLinks.forEach(link => {
    link.addEventListener('click', function () {
      closeDrawer();
    });
  });
});
